<template>
  <section class="message" @click="$emit('open-messages-modal')">
    <div v-if="time" class="meta">
      {{ time }}
    </div>

    <div class="content" v-html="content" />
  </section>
</template>

<script>
export default {
  name: "Message",

  props: {
    time: String,
    content: String,
  },
}
</script>

<style scoped lang="scss">
.message {
  color: #fff;
  font-size: 0.85rem;
  text-align: center;
  background: #2b2b2b;
  position: relative;
  cursor: pointer;
  transition: background 250ms;

  &:hover {
    background: #000;
  }
}

.content {
  padding: 1rem;
  max-width: 800px;
  margin: auto;
}

.meta {
  font-weight: bold;
  font-size: 0.65rem;
  background: rgba(#fff, 0.15);
  padding: 0.25rem;
  position: absolute;
  left: 0;
  top: 0;
}
</style>
